'use client'
import styles from "./Advantages.module.css"
import Image_NoDownloads from "@/assets/img/Image_NoGameDownloads.jpg"
import Image_OnAnyDevice from "@/assets/img/Image_OnAnyDevice.jpg"
import Image_UnlimitedGameSessions from "@/assets/img/Image_UnlimitedGameSessions.jpg"
import Image_HighDefinition from "@/assets/img/Image_HighDefinition.jpg"
import { StaticImageData } from "next/image";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";

function Card({ title, text, image }: { title: string, text: string, image: StaticImageData }) {
	return (
		<motion.div
			className={styles.card}
			initial={{ opacity: 0, y: 40 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true, amount: 1 }}
			transition={{ duration: 0.6 }}
		>
			<div className={`${styles.cardContent}`}>
				<h3 className="bodyTextLarge">{title}</h3>
				<p className="bodyTextMedium">{text}</p>
			</div>
		</motion.div>
	)
}

export default function Advantages () {
	const t = useTranslations("FrontPage.Advantages")

	const cards = [
		{
			title: t('card1_title'),
			text: t('card1_text'),
			image: Image_NoDownloads
		},
				{
			title: t('card2_title'),
			text: t('card2_text'),
			image: Image_OnAnyDevice
		},
		{
			title: t('card3_title'),
			text: t('card3_text'),
			image: Image_UnlimitedGameSessions
		},
		{
			title: t('card4_title'),
			text: t('card4_text'),
			image: Image_HighDefinition
		}
	]

	return (
		<section id={'advantages'} className={styles.main} data-scroll-section>
			<h2 className="title1">{t('title')}</h2>
			{cards.map(card => <Card title={card.title} text={card.text} image={card.image} key={card.title}/>)}
		</section>
	)
}